import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac632b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_3 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_4 = { style: {"box-sizing":"border-box","padding":"54px 5px","display":"flex","justify-content":"center","border":"solid 1px #e5e5e5","border-radius":"2px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi-tmpl-detail__right__cmpt__title" }, "请选择表格样式", -1))
const _hoisted_6 = ["onClick"]

import { ref } from 'vue';
import _ from 'lodash';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleMap from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-map.vue';
import PcModuleTable from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-table/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-18-2',
  setup(__props) {

const TYPE_MAPPING = PcModuleTable.reduce((pre, cur, i) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: 'pc-module-table-' + (i + 1),
    moduleType: cName
  };
  return pre;
}, {});

const tableHeaderList = ref([
  { prop: 'province', label: ['省份'] },
  { prop: 'zj', label: ['浙江'] },
  { prop: 'hb', label: ['湖北'] },
  { prop: 'bj', label: ['北京'] },
  { prop: 'sx', label: ['陕西'] },
  { prop: 'jl', label: ['吉林'] },
  { prop: 'sc', label: ['四川'] },
  { prop: 'other', label: ['其他'] }
]);
const tableDataList = ref([
  {
    province: ['有效点击率'],
    zj: ['186'],
    hb: ['99'],
    bj: ['99'],
    sx: ['86'],
    jl: ['77'],
    sc: ['49'],
    other: ['48']
  }
]);

const cmpName = name => {
  return PcModuleTable.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(curItem).title), 1),
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(PcModuleMap)
    ]),
    _hoisted_5,
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 120,
      itemWidth: 795 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"height":"120px","width":"100%"},
            key: index,
            onClick: ($event: any) => (_unref(onChange)(item.value))
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"795px","height":"120px"} }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.moduleType)), _mergeProps({
                  style: {"width":"1500px","transform":"scale(0.5)","transform-origin":"0 0"},
                  ref_for: true
                }, {
              tableHeaderList: tableHeaderList.value,
              tableDataList: tableDataList.value
            }), null, 16)),
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  value: item.value,
                  "model-value": _unref(curItem).value
                }, null, 8, ["value", "model-value"])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_6))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})